export default __webpack_public_path__ + "static/media/runtime-platform-1.60f57dcd.webp";